import React, { useState, useRef, Fragment, useCallback }  from 'react';
import classnames from 'classnames';
import { Manager, Reference, Popper } from 'react-popper';
import find from 'lodash/find';

import ClickAwayListener from '../utils/click-away-listener';

const Null = () => null;

const modifiers = {
  flip: { enabled: true },
  preventOverflow: { enabled: false },
  hide: { enabled: false },
};

const animatedModifiers = {
  ...modifiers,
  // We disable the built-in gpuAcceleration so that
  // Popper.js will return us easy to interpolate values
  // (top, left instead of transform: translate3d)
  // We'll then use these values to generate the needed
  // css tranform values blended with the react-spring values
  computeStyle: { gpuAcceleration: false },
}
function BasicDropDown(props) {
  const [open, setOpen] = useState(false);
  const dropdownListRef = useRef(null);
  const dropdownButtonRef = useRef(null);
  const toggleOpen = () => setOpen(!open);
  const btnClass = classnames({
    'btn': true,
    'btn-default': true,
    'btn-sm': true,
    'dropdown-toggle': true
  })
  const arrowIcon = classnames({
    'mdi': true,
    'mdi-menu-down': !open,
    'mdi-menu-up': open
  })
  const handleChange =function(evt) {
    const {selectValue} =props;
    const val =evt.currentTarget.dataset.value;
    if(evt) {
      selectValue(val || null);
    }else{
      selectValue(null);
    }
    
    toggleOpen();
  }

  const handleClickAway = function() {
    setOpen(false);
  }
  const setButtonRef = useCallback((node, ref) => {
    dropdownButtonRef.current = node;
    return ref(node);
  }, []);

  const setListRef = useCallback((node, ref) => {
    dropdownListRef.current = node;
    return ref(node);
  }, []);

  const {value, label, options, maxWidth, disabled} = props;
  let newLabel;
  if(value===0 ||typeof value === 'undefined' || value===null ) {
    newLabel =label;
  }else{
    newLabel =(find(options, {value})).label;
  }
  let content;

  if(disabled) {
    content =(
      <div
        className={btnClass + ' disabled'}
        tabIndex={0}
        style={{ cursor: 'pointer', display:'flex'}}
        title={newLabel}
        >
        <span className='overflow-ellipsis' style={{display:'block', position:'relative', flexGrow: 1}}>{newLabel}</span>                
        <i className={ arrowIcon } />
      </div>
    )
  }else{
    content=(
      <ClickAwayListener onClickAway={handleClickAway}>
        <div style={{maxWidth: maxWidth || '90%'}}>
          <Fragment>
            <Manager>
              <Reference>
                {({ ref }) => (
                  <div
                    className={btnClass}
                    tabIndex={0}
                    ref={node => setButtonRef(node, ref)}
                    style={{ cursor: 'pointer', display:'flex'}}
                    onClick={toggleOpen}
                    title={newLabel}
                    >
                    <span className='overflow-ellipsis' style={{display:'block', position:'relative', flexGrow: 1}}>{newLabel}</span>                
                    <i className={ arrowIcon } />
                  </div>
                )}
              </Reference>
              
                {
                  open && (
                      <Popper
                        positionFixed={true}
                        placement="bottom-start"
                        modifiers={animatedModifiers}
                      >
                        {({
                          ref,
                          style: { top, left, position},
                          placement,
                          arrowProps,
                        }) => (
                          <div
                            className='dropdown-menu-new'
                            ref={node => setListRef(node, ref)}
                            data-placement={placement}
                            style={{
                              listStyle: 'none',
                              fontSize: '13px',
                              textAlign: 'left',
                              backgroundColor: '#ffffff',
                              border: '1px solid rgba(0,0,0,0.15)',
                              borderRadius: '3px',                         
                              boxShadow: '0 6px 12px rgba(0,0,0,0.175)',
                              backgroundClip: 'padding-box',
                              opacity: 1,
                              top: 0,
                              left: 0,
                              position,
                              alignItems: 'center',
                              justifyContent: 'center',
                              maxHeight: `500px`,
                              zIndex:4,                          
                              padding: '1em',
                              transform: `translate3d(${left}px, ${top +
                                2}px, 0) `,
                              transformOrigin: 'top top',
                            }}
                          >
                            {options.map((obj)=>{
                              const liClass = classnames({
                                'active': value === obj.value,
                                'disabled': obj.disabled === true,
                              })
                              const spanClass = classnames({
                                'disabled': obj.disabled === true,
                              })
                            return(<li key={obj.value} className={liClass} title={obj.alias || obj.label} disabled={obj.disabled} onClick={obj.disabled ? null : handleChange} data-value={obj.value}><span className={spanClass}>{obj.label}</span></li>)
                            })}
                          </div>
                        )}
                      </Popper>
                    )}
             
            </Manager>
          </Fragment>
        </div>
     
      </ClickAwayListener>
    );
  }
  return content;
}
export default BasicDropDown;